import React from "react";
import Portfolio from "../components/Portfolio";

const PortfolioPage = () => (
  <div className="pt-20">
    <Portfolio />
  </div>
);

export default PortfolioPage;
